var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEasepay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.322,
    y1: -0.805,
    x2: 0.602,
    y2: 1.258,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff5e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#7d95e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#3f28dd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "EasyCollect",
    transform: "translate(-663 -55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6094",
    "data-name": "Rectangle 6094",
    width: 24,
    height: 24,
    transform: "translate(663 55)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Easy_Collect",
    "data-name": "Easy Collect",
    transform: "translate(665.4 57.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1928",
    "data-name": "Path 1928",
    d: "M17.165,7.557a5.3,5.3,0,0,1-.576,2.3A4.745,4.745,0,1,0,11.9,2.868h.494A4.706,4.706,0,0,1,17.165,7.557Z",
    transform: "translate(-2.357 -0.4)",
    fill: "#18253e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1929",
    "data-name": "Path 1929",
    d: "M10.272,4H9.778a4.785,4.785,0,1,0,4.689,7.075,4.362,4.362,0,0,0,.576-2.3A4.775,4.775,0,0,0,10.272,4Z",
    transform: "translate(-1.222 -1.038)",
    fill: "#33eeb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1930",
    "data-name": "Path 1930",
    d: "M11.446,8.174H9.225c-.247,0-.329-.082-.329-.247A.3.3,0,0,1,9.225,7.6h2.221c0-.082-.082-.165-.082-.247a1.186,1.186,0,0,0-1.07-.658H9.142c0,.082-.165,0-.165-.082-.165-.165,0-.411.247-.411H12.6c.165,0,.329.082.329.247a.3.3,0,0,1-.329.329h-.823c.165.247.247.576.411.823H12.6c.247,0,.329.082.329.329,0,.165-.165.247-.329.247h-.411a1.847,1.847,0,0,1-2.139,1.4c.082.082.082.165.165.165.576.576,1.152,1.152,1.81,1.728l.165.165a.374.374,0,0,1,0,.411.367.367,0,0,1-.411,0,.081.081,0,0,1-.082-.082c-.823-.74-1.563-1.563-2.386-2.3-.329-.165-.494-.247-.411-.411s.247-.165.411-.165h1.07A1.07,1.07,0,0,0,11.446,8.174Z",
    transform: "translate(-1.82 -1.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3251",
    "data-name": "Group 3251",
    transform: "translate(0 9.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3250",
    "data-name": "Group 3250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1931",
    "data-name": "Path 1931",
    d: "M9.926,17.612H5.977a.934.934,0,0,0-.658.247C4.249,18.929,3.1,20,2.028,21.068c-.329.494-.74.658-1.152.411A1.044,1.044,0,0,1,.3,20.409V17.777a1.321,1.321,0,0,1,.411-.9l3.7-3.7a1.518,1.518,0,0,1,.987-.411h6.746a1.035,1.035,0,0,1,1.152.9c0,.576-.411.9-1.152.9H9.679c-.165,0-.247.165-.411.247.165.082.247.247.411.247H14.2a.938.938,0,0,0,.494-.247c.987-.9,1.892-1.892,2.8-2.8.494-.494,1.07-.494,1.4-.082.411.411.329.9-.165,1.4l-3.784,3.784a1.518,1.518,0,0,1-.987.411A33.3,33.3,0,0,1,9.926,17.612Z",
    transform: "translate(-0.3 -11.637)",
    fill: "url(#linear-gradient)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasepay);
export default __webpack_public_path__ + "static/media/easepay.d3b1c1712dc3d75c38550067bfb7a5ea.svg";
export { ForwardRef as ReactComponent };